var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoSlash = function SvgVideoSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#video-slash_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#video-slash_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA007",
    stroke: "url(#video-slash_svg__c)",
    strokeLinecap: "round",
    d: "m28.833 7.46.404-.406-.455-.346a11 11 0 0 0-1.677-1.055c-1.29-.656-2.695-.938-4.34-1.072-1.605-.131-3.593-.131-6.09-.131h-.166c-2.497 0-4.486 0-6.09.131-1.645.134-3.051.416-4.34 1.072a11.04 11.04 0 0 0-4.825 4.826C.597 11.768.316 13.174.18 14.819.05 16.422.05 18.411.05 20.908v.166c0 2.497 0 4.485.131 6.09.135 1.645.416 3.05 1.073 4.34q.454.89 1.054 1.677l.347.455.404-.404zm7.364.19A1.875 1.875 0 0 0 33.545 5L2.432 36.111a1.875 1.875 0 1 0 2.652 2.651l2.002-2.001c1.012.358 2.106.54 3.332.64 1.605.131 3.593.131 6.09.131h.167c2.496 0 4.485 0 6.09-.13 1.645-.135 3.05-.416 4.34-1.073a11.04 11.04 0 0 0 4.885-4.946c1.93.841 3.569 1.537 4.929 1.906 1.565.424 3.212.547 4.707-.431 1.495-.979 2.042-2.537 2.28-4.141.227-1.538.227-3.547.227-5.945V19.21c0-2.398 0-4.407-.227-5.945-.238-1.603-.785-3.162-2.28-4.14s-3.142-.856-4.707-.431c-.812.22-1.724.557-2.736.97z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#video-slash_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#video-slash_svg__e)",
    fillRule: "evenodd",
    d: "M7.883 15.492c0-.76.616-1.375 1.375-1.375h7.334a1.375 1.375 0 1 1 0 2.75H9.258c-.76 0-1.375-.616-1.375-1.375",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "video-slash_svg__c",
    x1: 0.55,
    x2: 33.478,
    y1: 4.95,
    y2: 46.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "video-slash_svg__e",
    x1: 13.01,
    x2: 14.97,
    y1: 17.453,
    y2: 10.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "video-slash_svg__b",
    width: 93.083,
    height: 83.863,
    x: -24.45,
    y: -20.05,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_4621"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1_4621",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "video-slash_svg__d",
    width: 26.083,
    height: 18.75,
    x: 4.883,
    y: 11.117,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4621"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1_4621",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "video-slash_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};
export { SvgVideoSlash as ReactComponent };